// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m8kOkRIiOBRvSPFVmcko {
    position: relative;
    z-index: 301;
  overflow-x: hidden;
    overflow-x: hidden;
  }
  
  .ftBlyDmZRMa8mCJw7HVp {
    max-height: 100%;
    overflow-x: hidden;
    background: rgb(var(--primary-bg));
  }
  
  .T7c8BNn1v2f97FY3Hbfg {
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 510;
    line-height: 32px;
    letter-spacing: -0.264px;
    color: rgb(var(--placeholder-primary));
  }

  .RhZwuEY_O94_JGikFECA {
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.5px;
    color: rgb(var(--placeholder-secondary));
  }

  .lb90fCUxpRloh9s225pi {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    justify-items: start;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  .mT9OFOPS9SKHioSyeUkC {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  
  .DUlemsICl50gwQC8z4ym {
    color: #1c77ff;
    font-size: 16.5px;
    font-weight: 540;
    letter-spacing: 0.43px;
    padding: 0;
    background: transparent;
    cursor: pointer;
    border: none;
    transition: color 0.3s ease 0s;
  }
  
  .DUlemsICl50gwQC8z4ym:hover {
    color: #055ada;
    background: transparent;
  }
  
  .JumwQh6K1JARpGjqel7s {
    font-size: 17px;
    font-weight: 760;
    letter-spacing: 0.43px;
    line-height: 129.41%;
    margin: 0 auto;
  }
  
  .ecSgNhunb0DNsVMMOKUz {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 80%;
    gap: 20px;
  }
  
  .kCEnz5NyOSWVEFejwx_z {
    position: absolute;
    right: 50%;
    top: 50%;
    z-index: 50;
    transform: translate(50%, -50%);
    padding: 0;
    background: transparent;
  }
  
  .JzFoBGd8lmQ57JZ2pRvW {
    padding: 14px 21px;
    font-style: 17px;
    font-weight: 540;
    line-height: 129%;
    border-radius: 30px;
    background: #007AFF;
    letter-spacing: 0.63px;
    width: 100%;
    height: auto;
    margin-top: 20px;
  }
  
  .JzFoBGd8lmQ57JZ2pRvW:hover {
    background: #007AFF;
  }
  
  .mSZMw2atFUiEoGJiKGZK {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  .cmWOOXk0P7rSv8Xn9Iq_ {
    font-weight: 540;
  }
  
  .P95o1Wagx2yZyWkbYNat {
    margin: 20px 0;
  }
  .DBhFteWFHIbhGiKfYnA9 {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 760;
    line-height: 120%;
  }
  .xwaqgoi1RH13cXqPGQMV {
    padding: 13px;
    font-size: 17px;
    width: 100%;
    border-radius: 10px;
    background: rgba(118, 118, 128, 0.12);
    border: none;
    color: rgba(60, 60, 67, 0.6);
    margin-bottom: 20px;
  }
  
  
  /* check position */
  
  .zNLkRk79vn67Q3wPLkbA {
    background: radial-gradient(53.5% 40% at 50% 40%, rgba(0, 234, 23, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;
  }
  
  .r9rOdVCxGQfTvDbkYdGg {
    background: radial-gradient(53.5% 40% at 50% 40%, rgba(234, 42, 0, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;
  }
  
  .xhLqOOvuBzAVCnzJjSe6 {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
    height: 100%;
    margin-top: 36px;
  }
  
  .xhLqOOvuBzAVCnzJjSe6 img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 170px;
    height: 170px;
    margin: 0 auto 8px auto;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/swap/swapcheck/swapcheck.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;EACd,kBAAkB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;;EAGA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,+BAA+B;IAC/B,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;EACrB;;;EAGA,mBAAmB;;EAEnB;IACE,yHAAyH;EAC3H;;EAEA;IACE,yHAAyH;EAC3H;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB","sourcesContent":[".wrapper {\n    position: relative;\n    z-index: 301;\n  overflow-x: hidden;\n    overflow-x: hidden;\n  }\n  \n  .modal {\n    max-height: 100%;\n    overflow-x: hidden;\n    background: rgb(var(--primary-bg));\n  }\n  \n  .modalContentTitle {\n    text-align: center;\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 510;\n    line-height: 32px;\n    letter-spacing: -0.264px;\n    color: rgb(var(--placeholder-primary));\n  }\n\n  .modalContentText {\n    text-align: center;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: -0.5px;\n    color: rgb(var(--placeholder-secondary));\n  }\n\n  .modalTop {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    align-items: center;\n    justify-items: start;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .modalTopRight {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    align-items: center;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  \n  .modalTopButton {\n    color: #1c77ff;\n    font-size: 16.5px;\n    font-weight: 540;\n    letter-spacing: 0.43px;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    border: none;\n    transition: color 0.3s ease 0s;\n  }\n  \n  .modalTopButton:hover {\n    color: #055ada;\n    background: transparent;\n  }\n  \n  .modalTitle {\n    font-size: 17px;\n    font-weight: 760;\n    letter-spacing: 0.43px;\n    line-height: 129.41%;\n    margin: 0 auto;\n  }\n  \n  .modalContent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 80%;\n    gap: 20px;\n  }\n  \n  .modalContentSwap {\n    position: absolute;\n    right: 50%;\n    top: 50%;\n    z-index: 50;\n    transform: translate(50%, -50%);\n    padding: 0;\n    background: transparent;\n  }\n  \n  .button {\n    padding: 14px 21px;\n    font-style: 17px;\n    font-weight: 540;\n    line-height: 129%;\n    border-radius: 30px;\n    background: #007AFF;\n    letter-spacing: 0.63px;\n    width: 100%;\n    height: auto;\n    margin-top: 20px;\n  }\n  \n  .button:hover {\n    background: #007AFF;\n  }\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  \n  .modalContentMain {\n    font-weight: 540;\n  }\n  \n  .passwordBlock {\n    margin: 20px 0;\n  }\n  .passwordLabel {\n    margin-bottom: 15px;\n    font-size: 20px;\n    font-weight: 760;\n    line-height: 120%;\n  }\n  .passwordInput {\n    padding: 13px;\n    font-size: 17px;\n    width: 100%;\n    border-radius: 10px;\n    background: rgba(118, 118, 128, 0.12);\n    border: none;\n    color: rgba(60, 60, 67, 0.6);\n    margin-bottom: 20px;\n  }\n  \n  \n  /* check position */\n  \n  .success {\n    background: radial-gradient(53.5% 40% at 50% 40%, rgba(0, 234, 23, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;\n  }\n  \n  .error {\n    background: radial-gradient(53.5% 40% at 50% 40%, rgba(234, 42, 0, 0.50) 0%, rgba(255, 255, 255, 0.00) 100%), transparent;\n  }\n  \n  .checkContent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 20px;\n    height: 100%;\n    margin-top: 36px;\n  }\n  \n  .checkContent img {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 170px;\n    height: 170px;\n    margin: 0 auto 8px auto;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `m8kOkRIiOBRvSPFVmcko`,
	"modal": `ftBlyDmZRMa8mCJw7HVp`,
	"modalContentTitle": `T7c8BNn1v2f97FY3Hbfg`,
	"modalContentText": `RhZwuEY_O94_JGikFECA`,
	"modalTop": `lb90fCUxpRloh9s225pi`,
	"modalTopRight": `mT9OFOPS9SKHioSyeUkC`,
	"modalTopButton": `DUlemsICl50gwQC8z4ym`,
	"modalTitle": `JumwQh6K1JARpGjqel7s`,
	"modalContent": `ecSgNhunb0DNsVMMOKUz`,
	"modalContentSwap": `kCEnz5NyOSWVEFejwx_z`,
	"button": `JzFoBGd8lmQ57JZ2pRvW`,
	"container": `mSZMw2atFUiEoGJiKGZK`,
	"modalContentMain": `cmWOOXk0P7rSv8Xn9Iq_`,
	"passwordBlock": `P95o1Wagx2yZyWkbYNat`,
	"passwordLabel": `DBhFteWFHIbhGiKfYnA9`,
	"passwordInput": `xwaqgoi1RH13cXqPGQMV`,
	"success": `zNLkRk79vn67Q3wPLkbA`,
	"error": `r9rOdVCxGQfTvDbkYdGg`,
	"checkContent": `xhLqOOvuBzAVCnzJjSe6`
};
export default ___CSS_LOADER_EXPORT___;
